import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService, MenuItem } from "primeng/api";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/services/auth.service";
import { UserService } from "../../../../services/user.service";
import { CommonService } from "../../../../services/common.service";
import { KycService } from "src/app/services/kyc.service";
import { DomSanitizer } from "@angular/platform-browser";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { MustMatch } from "src/app/_helpers/must-match.validator";
@Component({
  selector: "app-kyc",
  templateUrl: "./kyc.component.html",
  styleUrls: ["./kyc.component.scss"],
  providers: [ConfirmationService, MessageService, KycService],
})
export class UserAadharKycComponent implements OnInit {
  items: MenuItem[];
  id;
  public loggedInUser;
  public isLoggedIn: boolean;
  public userId;
  public kycForm: FormGroup;
  public submitted: boolean = false;
  public showMessage: boolean = false;
  public isAcademy: boolean = false;
  public showErrorMessage: boolean = false;
  public showAadharForm: boolean = false;
  public showOtpErrors: boolean = false;
  public showGenerateOtpFailedMessage;
  public showThankyou: boolean = false;
  public showOtp: boolean = false;
  public aadharVerificationCompleted: boolean = false;
  public thankYouModal: boolean = false;
  public showPanForm: boolean = true;
  public showBankForm: boolean = false;
  public showPanFailedMessage;
  public kycId;
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  otp: any;
  public refId;
  public config = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    required: true,
    placeholder: '',
    inputStyles: {
      'width': '50px',
      'height': '50px'
    }
  };
  otpError: any;
  aadharOtp: boolean;
  aadharCardStep: boolean;
  thankYoumodal: boolean;
  step: number = 0;
  public activeIndex: number = 0;
  public panForm: FormGroup;
  public panSubmitted: boolean = false;
  public bankSubmitted: boolean = false;
  public kycCompleted: boolean = false;
  public bankForm: FormGroup;
  kycData: any;
  public kycBankDetails: any = [];
  aadhaarCardNumber: any;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private commonService: CommonService,
    private tokenStorage: TokenStorageService,
    private authService: AuthService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private renderer: Renderer2,
    private kycService: KycService,
    private sanitizer: DomSanitizer
  ) { }
  async ngOnInit(): Promise<void> {
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
      if (this.loggedInUser.userdata.aadharVerificationCompleted === true) {
        this.aadharVerificationCompleted = true;
        this.showThankyou = false;
        this.showOtp = false;
        this.showAadharForm = false;
      }
    }
    let roleName = this.loggedInUser.userdata.rolename;
    if (roleName == "academy") {
      this.isAcademy = true;
    }
    if (this.isLoggedIn == false) {
      this.router.navigate(["/"]);
    }
    this.id = this.userId;
    this.kycForm = this.formBuilder.group(
      {
        aadhaarCardNumber: [null, { validators: [Validators.required, Validators.pattern('[0-9]{12}')], updateOn: "blur" }],
      },);
    this.panForm = this.formBuilder.group(
      {
        panCardNumber: ['', { validators: [Validators.required, Validators.pattern('[A-Za-z]{3}[PCHFATBLJGpchfatbljg]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}$')], updateOn: "blur" }],
        gstNumber: ["", { validators: [Validators.pattern("[0-9]{2}[A-Za-z]{3}[CPHFATBLJGcphfatblj]{1}[A-Za-z]{1}[0-9]{4}[A-Za-z]{1}[0-9A-Za-z]{1}(Z|z)[0-9A-Za-z]{1}"),], updateOn: "blur", },],
      },);
    this.bankForm = this.formBuilder.group(
      {
        bankName: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z '][A-Za-z ']*$")], updateOn: "blur", },],
        name: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z '][A-Za-z ']*$")], updateOn: "blur", },],
        mobileNumber: [null, { validators: [Validators.required, Validators.pattern("[0-9 ]{10}")], updateOn: 'blur' }],
        bankAccountNumber: [null, { validators: [Validators.required, Validators.pattern('^[0-9]{9,18}$')], updateOn: "blur", },],
        confirmAccountNumber: ["", { validators: Validators.required, updateOn: "blur", },],
        ifscCode: ["", { validators: [Validators.required, Validators.pattern("^[A-Za-z]{4}0[A-Z0-9a-z]{6}$"),], updateOn: "blur", },],
      }, {
      validator: MustMatch("bankAccountNumber", "confirmAccountNumber"),
    });
    this.renderer.addClass(document.body, 'kyc-page');
    this.items = [{
      label: 'Pan Verification',
      command: (event: any) => {
        this.activeIndex = 0;
      }
    },
    {
      label: 'Aadhar Verification',
      command: (event: any) => {
        this.activeIndex = 1;
      }
    },
    {
      label: 'Bank Details',
      command: (event: any) => {
        this.activeIndex = 2;
      }
    },
    {
      label: 'Completed',
      command: (event: any) => {
        this.activeIndex = 3;
      }
    },
    ];
    await this.getKycDetails(this.userId);
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'kyc-page');
  }
  get f() {
    return this.kycForm.controls;
  }
  get panF() {
    return this.panForm.controls;
  }
  get bankF() {
    return this.bankForm.controls;
  }
  async getKycDetails(userId) {
    let query = "?filterByDisable=false&filterByStatus=true&filterByuserId=" + userId;
    this.userService.getUserKycDetailsList(query).subscribe(
      res => {
        this.kycData = res?.items?.[0];
        if (this.kycData?.isPanVerified === true) {
          this.kycId = this.kycData?.Id;
          this.activeIndex = 1;
          this.showAadharForm = true;
          this.showPanForm = false;
          this.showOtp = false;
        }
        if (this.kycData?.isAadharVerified === true) {
          this.kycId = this.kycData?.Id;
          this.activeIndex = 2;
          this.showAadharForm = false;
          this.showPanForm = false;
          this.showBankForm = true;
          this.showOtp = false;
        }
        this.getBankDetails(userId);
      },
      err => {
      }
    );
  }
  async getBankDetails(userId) {
    let query = "filterByDisable=false&filterByStatus=true&filterByuserId=" + userId;
    this.kycService.getUserKycBankList(userId, query).subscribe(
      res => {
        this.kycBankDetails = res?.items;
        if (this.kycBankDetails.length > 0 && this.kycData.isAadharVerified === true) {
          this.activeIndex = 3;
          this.kycCompleted = true;
        }
      },
      err => {
      }
    );
  }
  onSubmit(): void {
    this.getKycDetails(this.userId);
    this.submitted = true;
    //stop here if form is invalid
    if (this.kycForm.invalid) {
      return;
    }
    let kycData = this.kycForm.value;
    if (kycData['aadhaarCardNumber'].length < Number(12)) {
      this.showErrorMessage = true;
    } else {
      this.showErrorMessage = false;
    }
    this.showGenerateOtpFailedMessage = undefined;
    this.otpError = undefined;
    this.aadhaarCardNumber = String(kycData['aadhaarCardNumber']);
    this.kycService.generateOtp(kycData).subscribe(
      res => {
        if (res.reference_id) {
          this.refId = res.reference_id;
          this.showAadharForm = false;
          this.showOtp = true;
        } else {
          this.showGenerateOtpFailedMessage = res.message;
        }
      },
      err => {
        this.showGenerateOtpFailedMessage = err.error.error;
      }
    );
  }
  onPanSubmit(): void {
    this.panSubmitted = true;
    //stop here if form is invalid
    if (this.panForm.invalid) {
      return;
    }
    let kycData = this.panForm.value;
    // if (kycData['panCardNumber'].length < Number(10)) {
    //   this.showErrorMessage = true;
    // } else {
    //   this.showErrorMessage = false;
    // }
    this.kycService.panCardVerification(kycData).subscribe(
      res => {
        if (res.panDetails.status === "VALID") {
          this.showAadharForm = true;
          this.showPanForm = false;
          this.showOtp = false;
          this.kycId = res.id;
          this.activeIndex = 1;
          this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Pan verification completed.', life: 3000 });
        } else {
          this.showPanFailedMessage = res.message;
        }
      },
      err => {
        this.showPanFailedMessage = err.error.error;
      }
    );
  }
  onOtpSubmit() {
    if (this.otp == undefined || this.otp == '' || this.otp.length < 6) {
      this.showOtpErrors = true;
      return;
    } else {
      this.showOtpErrors = false;
    }
    let otpData = {};
    otpData['otp'] = this.otp;
    otpData['ref_id'] = this.refId;
    otpData['kycId'] = this.kycId;
    otpData['aadharCardNumber'] = this.aadhaarCardNumber;
    this.kycService.verifyOtp(otpData).subscribe(
      res => {
        if (res.status === "VALID") {
          if (this.kycBankDetails.length > 0) {
            this.activeIndex = 3;
            this.showBankForm = false;
            this.showPanForm = false;
            this.showAadharForm = false;
            this.kycCompleted = true;
          } else {
            this.showThankyou = true;
          }
          this.showAadharForm = false;
          this.showOtp = false;
        }
      },
      err => {
        this.showOtpErrors = false;
        this.otpError = err.error.error;
      }
    );
  }
  onOtpChange(otp) {
    this.otp = otp;
    this.showOtpErrors = false;
    this.otpError = undefined;
  }
  backToProfile() {
    if (this.isAcademy === true) {
      this.router.navigate(["/academies-profile"]);
    } else {
      this.router.navigate(["/profile-info"]);
    }
  }
  bankDetails() {
    this.aadharOtp = false;
    this.step = 1;
    this.thankYoumodal = false;
  }
  onActiveIndexChange(event) {
    if (event == 0) {
      this.step = 0;
      this.activeIndex = 0;
    }
    else if (event == 1) {
      this.step = 1;
      this.activeIndex = 1;
    } else if (event == 2) {
      this.activeIndex = 2;
      this.step = 2;
    }
  }
  skipAadharStep() {
    this.otp = '';
    this.activeIndex = 2;
    this.showBankForm = true;
    this.showPanForm = false;
    this.showAadharForm = false;
    if (this.kycBankDetails?.length > 0) {
      this.activeIndex = 3;
      this.showBankForm = false;
      this.showPanForm = false;
      this.showAadharForm = false;
      this.kycCompleted = true;
    }
  }
  onSubmitBankForm() {
    this.bankSubmitted = true;
    //stop here if form is invalid
    if (this.bankForm.invalid) {
      return;
    }
    let bankData = this.bankForm.value;
    bankData["isDocumentComplete"] = true
    delete bankData["confirmAccountNumber"];
    bankData["kycId"] = this.kycId;
    this.kycService.bankVerification(bankData).subscribe(
      (data) => {

        if (data?.data?.account_exists) {
          this.showMessage = true;
          this.bankSubmitted = false;
          this.kycCompleted = true;
          this.activeIndex = 3;
        } else {
          this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: data?.data?.message, life: 6000, });

        }
      },
      (err) => {
        this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 6000, });
      }
    );
  }
  onClickBankBack() {
    this.activeIndex = 1;
    this.showAadharForm = true;
    this.showBankForm = false;
    this.submitted = false;
  }
  onClickAadharBack() {
    this.otp = '';
    this.activeIndex = 0;
    this.showAadharForm = false;
    this.showPanForm = true;
    this.showBankForm = false;
    this.panSubmitted = false;
  }
  onClickOtpBack() {
    this.otp = '';
    this.showAadharForm = true;
    this.showOtp = false;
  }
  onBlur() {
    this.showGenerateOtpFailedMessage = undefined;
  }
  showBankFormstep() {
    this.showBankForm = true;
    this.activeIndex = 2;
    this.showThankyou = false;
  }
}
